/**
 * O aviso de acao que falhou, para as telas que nao mostram o erro no proprio lugar.
 *
 * Quem ja mostra o erro no formulario marca a mutacao com `ERRO_NA_TELA` e fica de
 * fora, para o mesmo erro nao aparecer duas vezes.
 */
import type { Mutation } from '@tanstack/react-query';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { readonly erroNaTela?: boolean };
  }
}

export const ERRO_NA_TELA = { erroNaTela: true } as const;

export interface Aviso {
  readonly id: number;
  readonly texto: string;
}

type Ouvinte = (avisos: readonly Aviso[]) => void;

let avisos: readonly Aviso[] = [];
let proximoId = 1;
const ouvintes = new Set<Ouvinte>();

function publicar(): void {
  for (const o of ouvintes) o(avisos);
}

export function ouvirAvisos(o: Ouvinte): () => void {
  ouvintes.add(o);
  o(avisos);
  return () => {
    ouvintes.delete(o);
  };
}

export function avisar(texto: string): number {
  const id = proximoId++;
  // O mesmo texto repetido vira um aviso so: dois cliques no mesmo botao quebrado
  // nao empilham dois cartoes iguais.
  avisos = [...avisos.filter((a) => a.texto !== texto), { id, texto }];
  publicar();
  return id;
}

export function dispensar(id: number): void {
  avisos = avisos.filter((a) => a.id !== id);
  publicar();
}

export function textoDoErro(err: unknown): string {
  if (err instanceof Error && err.message.trim() !== '') return err.message;
  return 'Não deu certo. Tente de novo em instantes.';
}

export function deveAvisar(mutation: Pick<Mutation<unknown, unknown, unknown>, 'meta'>): boolean {
  return mutation.meta?.erroNaTela !== true;
}
